import React from 'react'
import styled from 'styled-components'

import { formatNumber } from '../../../../../function/math'
import { FONTS } from '../../../../../constants'

export const SecondRow = React.memo(({ data }) => {
  const { _lob_name, lob_revenue, lob_percent } = data

  return (
    <Root>
      <FormWrapper>
        <Label>LOB</Label>
        <Text>{ _lob_name || '-' }</Text>
      </FormWrapper>
      <FormWrapper>
        <Label>LOB Rev.</Label>
        <Number>{ formatNumber(lob_revenue) }</Number>
      </FormWrapper>
      <FormWrapper>
        <Label>LOB %</Label>
        <Number>{ formatNumber(lob_percent) }%</Number>
      </FormWrapper>
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`

const Number = styled.span`
  font-family: NotoSans;
  font-weight: 600;
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`

const Text = styled.div`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/SecondRow.js